<template>
  <el-container>
    <el-main class="info-set">
      <div class="info-set-content">
        <div class="content-userinfo">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>VIP用户信息</span>
              <el-button
                style="float: right; padding: 3px 0"
                type="text"
                @click="isShowUserInfo = !isShowUserInfo"
                >{{ isShowUserInfo ? "隐藏信息" : "显示信息" }}</el-button
              >
            </div>
            <div class="card-content" v-if="isShowUserInfo">
              <el-input
                placeholder="电话："
                v-model="userInfoData.phoneNum"
                disabled
              >
              </el-input>
              <el-input placeholder="安装地址：" v-model="userInfoData.address">
              </el-input>
              <el-input placeholder="姓名：" v-model="userInfoData.name">
              </el-input>
              <el-input placeholder="身份证号：" v-model="userInfoData.idNo">
              </el-input>
              <div class="button-box">
                <el-button
                  v-if="!hasUserInfo"
                  type="primary"
                  @click="setUserInfo()"
                  >完成</el-button
                >
                <el-button
                  v-if="!hasUserInfo && catchUserInfo"
                  type="warning"
                  @click="
                    hasUserInfo = true;
                    catchUserInfo = false;
                  "
                  >取消修改
                </el-button>
                <el-button
                  v-if="hasUserInfo"
                  type="warning"
                  @click="
                    hasUserInfo = false;
                    catchUserInfo = true;
                  "
                  >修改信息
                </el-button>
              </div>
            </div>
          </el-card>
          <!-- 用户信息 -->
        </div>
        <div class="content-driveway" v-if="hasUserInfo">
          <div class="content-driveway-add">
            <div class="add-driveway-c">
              <div class="add-driveway-h">
                <el-select v-model="changeDrivewayID" @change="changeDriveway">
                  <el-option
                    v-for="item in drivewayList"
                    :key="item.drivewayId"
                    :value="item.drivewayId"
                    :label="item.drivewayName"
                  ></el-option>
                </el-select>
                <el-button
                  :type="showAddInput ? 'warning' : 'primary'"
                  @click="addDriveway()"
                  >{{ showAddInput ? "取消添加" : "添加通道" }}</el-button
                >
                <el-button type="danger" @click="removeDriveway()"
                  >删除通道</el-button
                >
              </div>
              <!-- 展示二维码 -->
              <div>
                <img src="" width="160" height="160" />
              </div>
              <div class="add-driveway-m" v-if="showAddInput">
                <el-input
                  placeholder="输入您设置的通道名称"
                  v-model="drivewayName"
                >
                  <template slot="prepend">通道名称：</template>
                  <el-button slot="append" @click="suerAddDriveway()"
                    >确定</el-button
                  >
                </el-input>
              </div>
            </div>
          </div>
          <div class="content-driveway-equment-add">
            <p v-if="changeDrivewayID == ''">暂无通道选择。。。</p>
            <div v-else class="equment-add-content">
              <p>主机设备绑定</p>
              <div class="show-online">
                <div>
                  <el-input
                    placeholder="主设备序列号"
                    v-model="boardId"
                    maxlength="32"
                  >
                    <template slot="prepend">主机设备</template>
                    <el-button slot="append" @click="querySeiBeiID('main')"
                      >绑定</el-button
                    >
                  </el-input>
                </div>
                <div>
                  <span>{{ mainStatus }}</span
                  >&nbsp;&nbsp;
                  <el-button
                    type="primary"
                    @click="queryDrivedOnline(boardId, 'main')"
                    >刷新</el-button
                  >
                </div>
              </div>
            </div>
            <div
              class="equment-add-other"
              v-if="showOther && changeDrivewayID != ''"
            >
              <p>从机设备绑定</p>
              <div class="show-online">
                <div>
                  <el-input
                    placeholder="从机设备列号"
                    v-model="boardMinorId"
                    maxlength="32"
                  >
                    <template slot="prepend">从机设备</template>
                    <el-button slot="append" @click="querySeiBeiID('sn')"
                      >绑定</el-button
                    >
                  </el-input>
                </div>
                <div>
                  <span>{{ cStatus }}</span
                  >&nbsp;&nbsp;
                  <el-button
                    type="primary"
                    @click="queryDrivedOnline(boardMinorId)"
                    >刷新</el-button
                  >
                </div>
              </div>
            </div>
            <div
              class="equment-add-other"
              v-if="showOther && changeDrivewayID != ''"
            >
              <p>其他设备绑定</p>
              <div class="show-online">
                <div>
                  <el-input
                    placeholder="相机序列号"
                    v-model="camearId"
                    maxlength="32"
                  >
                    <template slot="prepend">相机设备</template>
                    <el-button slot="append" @click="querySeiBeiID('camear')"
                      >绑定</el-button
                    >
                  </el-input>
                </div>
                <div></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="info-set-doc">
        <!-- 操作说明 -->
        <h4>详情与说明</h4>
        <p v-for="(item, index) in docTitle" :key="index">
          {{ item }}
        </p>
      </div>
    </el-main>
  </el-container>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      that: this,
      hasUserInfo: false, //是否有用户信息
      catchUserInfo: false, //是否修改用户信息
      userInfoData: {
        address: "",
        name: "",
        phoneNum: "",
        idNo: "",
      },
      docTitle: [
        "一、填写完整VIP用户资料后可进行余下相关操作噢！",
        "二、创建通道、为随后的设备绑定创建基础",
        "三、绑定设备后绑定相应的使用的设备（如：设备主机、人脸识别机）",
      ],
      isShowUserInfo: true, //显示通道BOX
      drivewayList: [], //通道列表
      changeDrivewayID: "", //选中的通道ID
      showAddInput: false, //显示添加通道输入框
      drivewayName: "", //添加通道的名称
      boardId: "", //设备序列号
      boardMinorId: "", //设备序列号
      camearId: "", //相机ID
      drivewayOnline: true, //设备是否在线
      mainStatus: "在线",
      cStatus: "在线",
      showOther: false, //显示其他
    };
  },
  watch: {},
  computed: {
    ...mapGetters(["userinfo"]),
  },
  created() {
    this.getUserInfoData();
  },
  mounted() {},
  methods: {
    /*
     **  @description 获取用户信息
     **  @param {}
     **  @return
     **  @author shipingan
     */
    getUserInfoData() {
      let params = {
        loginId: this.userinfo.uid,
      };
      this.$axios
        .post("/dapi/nser/queryUser", this.$qs.stringify(params))
        .then((res) => {
          let data = res.data;
          if (data.status == 200) {
            this.userInfoData = data.data;
            if (
              this.userInfoData.idNo != "" &&
              this.userInfoData.idNo != undefined
            ) {
              this.getDrivewayDataList();
              this.hasUserInfo = true;
              this.catchUserInfo = true;
            }
          } else {
            this.$message.error(data.message);
          }
        })
        .catch((err) => {
          this.$message.error("服务器异常");
        });
    },
    /*
     **  @description 设置用户信息
     **  @param {}
     **  @return
     **  @author shipingan
     */
    setUserInfo() {
      if (this.userInfoData.address == "") {
        this.$message.error("请填写地址");
        return;
      }
      if (this.userInfoData.name == "") {
        this.$message.error("请填写姓名");
        return;
      }
      if (this.userInfoData.idNo == "") {
        this.$message.error("请填写身份证号");
        return;
      }
      let params = {
        loginId: this.userinfo.uid,
      };
      Object.assign(params, {
        ...this.userInfoData,
      });
      this.$axios
        .post("/dapi/nser/verified", this.$qs.stringify(params))
        .then((res) => {
          let data = res.data;
          if (data.status == 200) {
            this.getUserInfoData();
            this.$message({
              type: "success",
              message: data.data.resMsg,
            });
          } else {
            this.$message.error(data.message);
          }
        })
        .catch((err) => {
          this.$message.error("服务器异常");
        });
    },
    /*
     **  @description 查询通道
     **  @param {}
     **  @return
     **  @author shipingan
     */
    getDrivewayDataList() {
      this.$axios
        .get(`/dapi/nhw/driveway/find?drivewayArea=${this.userinfo.uid}`)
        .then((res) => {
          let data = res.data;
          if (data.status == 200) {
            if (data.data.length > 0) {
              this.drivewayList = data.data;
              this.changeDrivewayID = this.drivewayList[0].drivewayId;
              this.changeDriveway();
            }
          } else {
            this.drivewayList = [];
            this.changeDrivewayID = "";
            this.$message.error("暂无通道数据");
          }
        });
    },
    /*
     **  @description 选择通道
     **  @param {}
     **  @return
     **  @author shipingan
     */
    changeDriveway() {
      this.boardId = "";
      this.boardMinorId = "";
      this.camearId = "";
      this.showOther = false;
      let OBJ = this.drivewayList.find(
        (key) => key.drivewayId == this.changeDrivewayID
      );
      this.boardId = OBJ.drivewayBoard;
      this.boardMinorId = OBJ.drivewayBoardMinor;
      this.camearId = OBJ.drivewayCamera;
      if (this.boardId != "" && this.boardId) {
        this.showOther = true;
        this.queryDrivedOnline(this.boardId, "main");
        this.queryDrivedOnline(this.boardMinorId);
      }
    },
    /**
     * @description 查询设备是否在线
     * @param {}
     * @return
     * @author shipingan
     **/
    queryDrivedOnline(sn, who) {
      if (!sn) return;
      this.$axios.get("/dapi/nhw/getBoardStates?sn=" + sn).then((res) => {
        if (res.status != 200) {
          this.$message.error("服务异常");
          return;
        }
        if (who) {
          // 主机
          this.mainStatus = res.data.message;
        } else {
          // 从机
          this.cStatus = res.data.message;
        }
      });
    },
    /*
     **  @description 添加通道
     **  @param {}
     **  @return
     **  @author shipingan
     */
    addDriveway() {
      this.showAddInput = !this.showAddInput;
    },
    suerAddDriveway() {
      if (this.drivewayName == "") {
        this.$message.error("请输入通道名称");
        return;
      }
      let name = this.drivewayList.find(
        (key) => key.drivewayName == this.drivewayName
      );
      if (name) {
        this.$message.error("您添加的通道名称已存在，请重新输入");
        return;
      }
      let params = {
        drivewayName: this.drivewayName,
        drivewayArea: this.userinfo.uid,
      };

      this.$axios
        .post("/dapi/nhw/driveway/add", this.$qs.stringify(params))
        .then((res) => {
          let data = res.data;
          if (data.status == 200) {
            this.getDrivewayDataList();
            this.showAddInput = false;
            this.$message({
              type: "success",
              message: data.message,
            });
          }
        });
    },
    /*
     **  @description 绑定产品---查看ID是否使用
     **  @param {}
     **  @return
     **  @author shipingan
     */
    querySeiBeiID(who) {
      let findParams = {
        hardwareSn: "",
      };
      if (who == "main") {
        findParams.hardwareSn = this.boardId;
        if (this.boardId == null || this.boardId == "") {
          this.$message.error("请输入设备编码");
          return;
        }
      }
      if (who == "camear") {
        findParams.hardwareSn = this.camearId;
        if (this.camearId == null || this.camearId == "") {
          this.$message.error("请输入设备编码");
          return;
        }
      }
      if (who == "sn") {
        findParams.hardwareSn = this.boardMinorId;
        if (this.boardMinorId == null || this.boardMinorId == "") {
          this.$message.error("请输入设备编码");
          return;
        }
      }
      // 查看序列号是否被使用
      this.$axios
        .get(`/dapi/nhw/hardware/findBySn?hardwareSn=${findParams.hardwareSn}`)
        .then((res) => {
          let data = res.data;
          if (data.status == 200) {
            // if (data.data.hardwareIsUsed == 1) {
            //   this.$message.error("设备已被绑定");
            //   return;
            // }
            switch (who) {
              case "main":
                data.data.hardwareType == 1
                  ? this.setEqument({ boardId: this.boardId })
                  : this.$message.error("请输入闸道控制板编码");
                break;
              case "sn":
                data.data.hardwareType == 1
                  ? this.setEqument({ minorId: this.boardMinorId })
                  : this.$message.error("请输入闸道控制板编码");
                break;
              case "camear":
                data.data.hardwareType == 2 || data.data.hardwareType == 3
                  ? this.setEqument({ cameraId: this.cameraId })
                  : this.$message.error("请输入相机编码");
                break;
              default:
                break;
            }
          } else if (data.status == 2) {
            this.$message.error(data.message);
          } else {
            this.$message.error(data.message);
          }
        });
    },
    /*
     **  @description 硬件绑定
     **  @param {}
     **  @return
     **  @author shipingan
     */
    setEqument(objId) {
      let params = Object.assign(
        {
          drivewayId: this.changeDrivewayID,
        },
        objId
      );
      this.$axios
        .post("/dapi/nhw/driveway/addHd", this.$qs.stringify(params))
        .then((res) => {
          let data = res.data;
          if (data.status == 200) {
            this.$message({
              type: "success",
              message: data.message,
            });
            this.getDrivewayDataList();
          } else {
            this.$message.error(data.message);
          }
        });
    },
    /*
     **  @description 删除通道
     **  @param {}
     **  @return
     **  @author shipingan
     */
    removeDriveway() {
      let url = "/dapi/nhw/driveway/delete";
      let params = {
        drivewayId: this.changeDrivewayID,
      };
      this.$axios.post(url, this.$qs.stringify(params)).then((res) => {
        let data = res.data;
        if (data.status == 200) {
          this.$message({
            type: "success",
            message: "删除成功",
          });
          this.getDrivewayDataList();
        } else {
          this.$message.error(data.message);
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
@box-shadow: 0 0 10px #ccc;
.info-set {
  display: flex;
  justify-content: space-between;
  .info-set-content {
    min-width: 800px;
    flex: 2;
    .content-userinfo {
      box-shadow: @box-shadow;
      margin-bottom: 20px;
      padding: 20px;
      .card-content {
        // background-color: rgba(64, 158, 255, 0.5);
        &:nth-last-child(1) {
          margin-bottom: 20px;
        }
        .el-input {
          margin: 10px 0;
          width: 400px;
        }
      }
      .box-card {
        max-width: 500px;
      }
    }
    .content-driveway {
      box-shadow: @box-shadow;
      padding: 20px;
      display: flex;
      justify-content: space-between;
      .content-driveway-add {
        flex: 1;
        margin: 10px;
        padding: 10px;
        box-shadow: @box-shadow;
        .add-driveway-c {
          .add-driveway-h {
            margin: 20px;
            display: flex;
            // justify-content: space-around;
            .el-button {
              margin-left: 20px;
            }
          }
          .add-driveway-m {
            margin: 20px;
            text-align: left;
            .el-input {
              width: 300px;
            }
          }
        }
      }
      .content-driveway-equment-add {
        flex: 1;
        margin: 10px;
        padding: 10px;
        box-shadow: @box-shadow;
        .equment-add-content {
          padding: 20px;
          p {
            border-left: 10px solid #409eff;
            text-align: left;
            margin-top: 0;
            padding-left: 5px;
          }
        }
        .equment-add-other {
          .equment-add-content;
        }
      }
    }
  }
  .show-online {
    display: flex;
    & > div {
      flex: 1;
    }
    & > div:nth-of-type(1) {
      flex: 2;
    }
  }
  .info-set-doc {
    box-shadow: @box-shadow;
    margin-left: 40px;
    padding: 20px;
    flex: 1;
    p {
      text-align: left;
    }
  }
}
</style>
